module.exports = __webpack_public_path__ + "img/descript.1e3be6a8.png";